<template>
  <!-- 作业考试 -->
  <div class="main-contain">
    <div class="contain">
      <div class="hw-header">
        <div class="intro-title">
          <el-image :src="courseImg" class="title-icon" />
          <div class="title-text"><span>作业考试</span></div>
        </div>
        <div class="hw-actions">
          <el-select v-model="queryType" placeholder="全部类型" size="small" class="type-select" @change="changeType">
            <el-option label="全部类型" :value="0"></el-option>
            <el-option label="作业" :value="1"></el-option>
            <el-option label="考试" :value="2"></el-option>
          </el-select>
        </div>
      </div>

      <!-- <div class="hw-filters">
        <div class="filter-item" v-for="filter in filterList" :key="filter.value"
          :class="{ active: state === filter.value }" @click="changeState(filter.value)">
          <span>{{ filter.label }}</span>
          <span class="filter-count">({{ filterCounts[filter.value] || 0 }})</span>
        </div>
      </div> -->

      <div class="hw-list">
        <div class="hw-card" v-for="(item, index) in tableData" :key="index">
          <div class="hw-card-main">
            <div class="hw-icon" :class="item.type == 2 ? 'exam' : 'homework'">
              <el-image :src="item.type == 2 ? examIcon : homeworkIcon" class="hw-icon-img" />
              <!-- <i :class="item.type == 2 ? 'el-icon-edit-outline' : 'el-icon-document'"></i> -->
            </div>
            <div class="hw-info">
              <div class="hw-title-row">
                <span class="hw-title">{{ item.name }}</span>
                <span class="hw-type-tag" :class="item.type == 2 ? 'exam-tag' : 'homework-tag'">{{ item.type |
                  typeformat }}</span>
              </div>
              <div class="hw-chapter" v-if="item.chapter_name">相关章节：{{ item.chapter_name }}</div>
              <div class="hw-chapter" v-else>相关章节：第一章第六节</div>

            </div>
            <div class="hw-metrics">
              <div class="line"></div>
              <div class="metric-item">
                <div class="metric-label">题目数量</div>
                <div class="metric-value">{{ item.total_stem_count }}</div>
              </div>
              <div class="line"></div>
              <div class="metric-item">
                <div class="metric-label">总分数</div>
                <div class="metric-value">{{ item.total_score }}</div>
              </div>
              <div class="line"></div>
              <div class="metric-item">
                <div class="metric-label">截止时间</div>
                <div class="metric-value">{{ item.end_time | dataformat }}</div>
              </div>
            </div>
            <div class="hw-status">
              <!-- 未提交 -->
              <template v-if="item.test_period_user_status == null || item.test_period_user_status == 0">
                <template v-if="item.access_status">
                  <div v-if="Math.floor(Date.now() / 1000) < item.start_time" class="status-text status-gray">未开始</div>
                  <div v-else-if="Math.floor(Date.now() / 1000) > item.end_time" class="status-text status-red">已截止
                  </div>
                  <div v-else class="btn-primary" @click="toAnswer(item)">去答题</div>
                </template>
                <div v-else class="status-text status-gray">无权限</div>
              </template>
              <!-- 已提交 -->
              <template v-else>
                <template v-if="item.review_status == 1">
                  <div class="score-box">
                    <span class="score-value">{{ item.user_score }}</span>
                    <span class="score-unit">分</span>
                  </div>
                  <div class="link-text" @click="toDetail(item)">答题详情 &gt;</div>
                </template>
                <template v-else>
                  <div v-if="item.test_period_user_status == 2">
                    <div class="status-text status-red">打回</div>
                    <div class="link-text" @click="toAnswer(item)">重新答题 &gt;</div>
                  </div>
                  <div v-else>
                    <div class="status-text status-orange">批阅中</div>
                    <div class="link-text" @click="toDetail(item)">答题详情 &gt;</div>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
        <div class="empty-tip" v-if="tableData.length === 0">
          <div class="is-empty" style="text-align: center">
            <img :src="no_math" />
            <div style="
            font-size: 18px;
            color: #b5a2a2;
            margin-bottom: 30px;
            text-align: center;
          ">
              <span>暂无作业数据</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <!-- <pag-table
        class="paginationBox"
        :total="total"
        :page="page"
        :limit="per_page"
        @changeSize="changeSize"
        @changePage="changePage"
        style="margin-top: 10px; text-align: center"
      />-->
    </div>
    <!-- 关联章节 -->
    <Customdialog class="customdialog" ref="dialog_catalogue" type="max" title="关联章节" width="800px" :showclose="true">
      <div slot="dialogbody" class="dialogbody">
        <Table ref="chapters"></Table>
      </div>
      <div slot="dialogfooter" class="dialogfooter"></div>
    </Customdialog>
    <!-- 试卷详情 -->
    <Customdialog class="customdialog" ref="dialog_testdetail" type="min" :title="testTitle" width="50%"
      :showclose="true">
      <div slot="dialogbody" class="dialogbody">
        <div class="my_test">
          <div class="remark" v-if="isRightness">老师评语：{{ testInfo.user_remark }}</div>
          <div v-for="(item, index) in testStemList" :key="index">
            <div class="topic_type">
              <div class="order">{{ AutoNumberByIndex(item.type - 1) }}</div>
              <div class="classify">{{ item.type | stemformat }}</div>
              <div class="score">（{{ item.child.length }}题，共{{ item.score }}分）</div>
            </div>
            <div class="subject" v-for="(stem, si) in item.child" :key="si">
              <div class="question">
                <div class="order">{{ si + 1 }},</div>
                <div class="score">({{ stem.score }}分)</div>
                <div class="title" v-html="stem.title"></div>
              </div>
              <template v-if="item.type < 3">
                <div class="option" v-for="(option, oi) in stem.option" :key="oi"
                  :style="item.type == 3 ? 'margin-bottom:10px' : ''">
                  <div :class="option.is_check
                    ? 'order qs_right qs_active'
                    : 'order qs_right'
                    ">{{ AutoNumberByLetter(oi) }}</div>
                  <div class="content" v-html="option.content"></div>
                </div>
              </template>
              <template v-if="stem.user_answer && stem.user_answer.answer">
                <div class="user_answer">
                  <div class="imgAnalysis" v-if="isRightness">
                    <img v-if="stem.user_answer.is_right" src="@/assets/right.png" />
                    <img v-else src="@/assets/wrong.png" />
                  </div>
                  <div class="content">
                    <div class="user_section">
                      <div class="section_title">学生答案：</div>
                      <div class="answer" v-if="stem.user_answer.answer">
                        <template v-if="stem.user_answer.answer.length === 0">
                          <span style="color: red">[未答题]</span>
                        </template>
                        <template v-else>
                          <div class="answer_item" v-for="(answer, ai) in stem.user_answer.answer" :key="ai">
                            <template v-if="item.type < 4">
                              <div v-for="(option, oi) in stem.option" :key="oi">
                                <div v-if="answer && answer == option.id" style="min-width: 30px; margin: 0 5px">
                                  <span v-if="item.type == 3">
                                    {{
                                      oi == 0 ? "正确" : "错误"
                                    }}
                                  </span>
                                  <span v-else>
                                    {{
                                      AutoNumberByLetter(oi)
                                    }}
                                  </span>
                                </div>
                              </div>
                            </template>
                            <template v-if="item.type == 4">
                              <div v-if="answer" style="
                                  display: flex;
                                  min-width: 30px;
                                  margin: 0 5px;
                                ">
                                <span>{{ ai + 1 }}、</span>
                                <span v-html="answer"></span>
                              </div>
                            </template>
                            <template v-if="item.type > 4">
                              <div v-if="answer" v-html="answer" class="oa"></div>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div class="score" v-if="isRightness" style="margin-left: 10px">
                        得分：{{
                          stem.user_answer.score ? stem.user_answer.score : 0
                        }}
                      </div>
                    </div>
                    <div class="user_section" v-if="stem.user_answer.file_list.length > 0">
                      <div class="section_title">附件：</div>
                      <div class="file_list">
                        <div class="file" v-for="(file, fo) in stem.user_answer.file_list" :key="fo"
                          @click="appendix(file.url)">{{
                            file.name }}</div>
                      </div>
                    </div>
                    <div class="remark user_section" v-if="isRightness">
                      评语：{{
                        stem.user_answer.remark ? stem.user_answer.remark : ""
                      }}
                    </div>
                    <div class="user_section" v-if="isRightness">
                      <div class="section_title">标准答案：</div>
                      <div class="rightness">
                        <div class="answer_item" v-for="(option, oi) in stem.option" :key="oi">
                          <div v-if="option.is_right">
                            <span v-if="item.type < 3">
                              {{
                                AutoNumberByLetter(oi)
                              }}
                            </span>
                            <span v-else-if="item.type == 3">
                              {{
                                oi == 0 ? "正确" : "错误"
                              }}
                            </span>
                            <span v-else-if="item.type == 4" style="display: flex; margin-right: 5px">
                              <span>{{ oi + 1 }}、</span>
                              <span v-html="option.content"></span>
                            </span>
                            <span v-else v-html="option.content"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div slot="dialogfooter" class="dialogfooter"></div>
    </Customdialog>
    <!-- 附件预览弹框 -->
    <el-dialog title="附件预览" :visible.sync="appendixDialogVisible" width="70%" :before-close="handleAppendixClose"
      custom-class="appendix-dialog" top="5vh">
      <div class="appendix-preview">
        <iframe v-if="previewUrl" :src="previewUrl" frameborder="0" style="width: 100%; height: 70vh;"></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs"
import Table from "./table"
import Customdialog from "@/components/customdialog.vue"
import pagTable from "@/components/Pagination/pagTable"
import { gettestperiodList } from "@/api/testperiod"
import { gettestperioduserInfo } from "@/api/testperioduser"
import { Base64 } from "js-base64"

const request_base_path = require("@/utils/base_url")
// 试卷类型
const typeMap = ["其他", "作业", "考试"]
// 题目类型：0：其他，1：单选，2：多选，3：判断，4：填空，5：简答
const stemMap = {
  0: "其他题",
  1: "单选题",
  2: "多选题",
  3: "判断题",
  4: "填空题",
  5: "简答题",
}

export default {
  name: "virtualexperiment",
  components: {
    Customdialog,
    Table,
    pagTable,
  },

  data() {
    return {
      courseKey: "", // 课程编号
      tableData: [], // 试卷列表
      per_page: 100, // 每页条数
      page: 1,
      total: 0,
      state: 0, // 0全部 1未提交 2已提交
      queryType: 0, // 全部类型 0全部 1作业 2考试
      filterList: [
        { label: "全部", value: 0 },
        { label: "未提交", value: 1 },
        { label: "已提交", value: 2 },
      ],
      filterCounts: {
        0: 0,
        1: 0,
        2: 0,
      },
      testIcon: require("@/assets/coursedetails/组 10.png"),
      courseImg: require("@/assets/course/UIout/courseintro/courseintro_decor_01.png"),
      examIcon: require("@/assets/course/UIout/test/test_ico_test.png"),
      homeworkIcon: require("@/assets/course/UIout/test/test_ico_homework.png"),
      no_math: require("@/assets/no_math1.png"), // 没有公式
      testTitle: "", // 查看试卷的名称
      testInfo: {},
      testStemList: [], // 试卷试题库
      isRightness: false, // 是否有正解
      filePreview: "", // 数据预览
      picturesPreview: "", // 多图预览
      fileTask: "", // 数据预埋
      appendixDialogVisible: false, // 附件预览弹框显隐
      previewUrl: "", // 预览地址
    }
  },
  filters: {
    dataformat(value) {
      if (!value) return ""
      return dayjs.unix(value).format("YYYY-MM-DD HH:mm:ss")
    },
    typeformat(val) {
      return typeMap[val]
    },
    stemformat(status) {
      return stemMap[status]
    },
  },
  computed: {
    isUnSubmittedState() {
      return this.state === 0;
    },
  },
  // watch: {
  //   resStemList: {
  //     handler(newV) {
  //       if (!newV.length) {
  //         return false;
  //       }
  //       this.stemList = this.AutoNumberByLetter(newV);
  //     },
  //     immediate: true,
  //     deep: true,
  //   },
  // },
  created() {
    const systemConfig = sessionStorage.getItem("systemConfig")
    const systemInfo = systemConfig ? JSON.parse(systemConfig) : {}
    if (systemInfo.file_preview_url) {
      this.filePreview = systemInfo.file_preview_url + "/onlinePreview?url=" // 数据预览
      this.picturesPreview = systemInfo.file_preview_url + "/picturesPreview?urls=" // 多图预览
      this.fileTask = systemInfo.file_preview_url + "/addTask?url=" // 数据预埋
    } else {
      this.filePreview = request_base_path.pro_url + "/file-preview/onlinePreview?url=" // 数据预览
      this.picturesPreview = request_base_path.pro_url + "/file-preview/picturesPreview?urls=" // 多图预览
      this.fileTask = request_base_path.pro_url + "/file-preview/addTask?url=" // 数据预埋
    }
  },
  methods: {
    // 进入页面加载口
    initdata(obj, courseKey) {
      console.log("作业考试", obj, courseKey)
      if (courseKey) {
        this.courseKey = courseKey
        // this.getFilterCounts()
        this.gettestperiodList()
      }
    },
    // 获取作业考试列表
    gettestperiodList() {
      this.tableData = []
      let params = {
        course_semester_sn: this.courseKey, // 课程编号
        id_type: 1,
        per_page: this.per_page, // 每页条数
        page: this.page, // 当前页数
      }
      // 状态筛选 0全部 1未提交 2已提交
      if (this.state === 1) {
        params.test_period_user_status = 0 // 用户试卷状态，0：未提交
      } else if (this.state === 2) {
        params.test_period_user_status_is_submit = 1 // 获取已提交的 (包含作业状态为已提交 和 驳回的)
      }
      // 类型筛选 0全部 1作业 2考试
      if (this.queryType) {
        params.type = this.queryType
      }
      gettestperiodList(params)
        .then((res) => {
          console.log(res)
          if (res.code === 0 && res.data) {
            // 过滤无权限数据
            this.tableData = res.data.data.filter((item) => {
              return item.access_status === 1
            })
            this.total = res.data.total
          } else {
            console.log("试卷列表：", res.message)
          }
        })
        .catch((error) => {
          console.log("试卷列表：", error)
        })
    },
    // 切换单页条数
    changeSize(data) {
      this.per_page = parseInt(data)
      this.gettestperiodList()
    },
    // 切换当前页数
    changePage(data) {
      this.page = parseInt(data)
      this.gettestperiodList()
    },
    // 赛选查询
    changeState(value) {
      this.state = parseInt(value)
      this.page = 1
      this.gettestperiodList()
    },
    // 类型筛选
    changeType() {
      this.page = 1
      // this.getFilterCounts()
      this.gettestperiodList()
    },
    // 获取各筛选条件数量
    // async getFilterCounts() {
    //   const requests = this.filterList.map((filter) => {
    //     const params = {
    //       course_semester_sn: this.courseKey,
    //       id_type: 1,
    //       per_page: 1,
    //       page: 1,
    //     }
    //     if (filter.value === 1) {
    //       params.test_period_user_status = 0
    //     } else if (filter.value === 2) {
    //       params.test_period_user_status_is_submit = 1
    //     }
    //     if (this.queryType) {
    //       params.type = this.queryType
    //     }
    //     return gettestperiodList(params)
    //       .then((res) => {
    //         if (res.code === 0 && res.data) {
    //           // console.log(res, filter.value, '2025');

    //           return { value: filter.value, total: res.data.total || 0 }
    //         }
    //         return { value: filter.value, total: 0 }
    //       })
    //       .catch(() => ({ value: filter.value, total: 0 }))
    //   })
    //   const results = await Promise.all(requests)
    //   results.forEach((r) => {
    //     this.$set(this.filterCounts, r.value, r.total)
    //   })
    // },

    // 查看章节
    lookbt(id) {
      this.$refs.dialog_catalogue.dialogopenbt()
      this.$nextTick(() => {
        this.$refs.chapters.initdata(this.courseKey, id)
      })
    },
    // 回答
    toAnswer(row) {
      let params = { test_period_id: row.test_period_id }
      gettestperioduserInfo(params).then((res) => {
        if (res.code === 0) {
          let date = new Date()
          let now = parseInt(date.getTime() / 1000) // 当前时分秒
          //console.log("当前状态：" + row.status)
          //console.log("现在时间：" + now + "小于考试时间：" + row.start_time + "时不允许进入答题")
          let start = dayjs.unix(row.start_time).format("YYYY-MM-DD HH:mm:ss")
          // 判断考试状态
          if (row.status == 1) {
            if (now < row.start_time) {
              this.$message.warning("考试开始时间为: " + start)
            } else {
              this.$router.replace({
                path: "/home/wisdompracticeteaching/answer",
                query: {
                  test_period_id: row.test_period_id,
                  course_semester_sn: this.courseKey,
                  page_type: 0,
                },
              })
            }
          } else if (row.status == 2) {
            // this.$message.warning("已结束,无法答题!")
            this.$router.replace({
              path: "/home/wisdompracticeteaching/answer",
              query: {
                test_period_id: row.test_period_id,
                course_semester_sn: this.courseKey,
                page_type: 0,
              },
            })
          } else {
            this.$message.warning("考试开始时间为: " + start)
          }
        }
      })
    },
    // 详情
    toDetail(row) {
      this.isRightness = false // 起始关闭
      this.testTitle = row.test_name // 获取当前试卷名
      let params = { test_period_id: row.test_period_id }
      gettestperioduserInfo(params).then((res) => {
        if (res.code === 0) {
          this.testInfo = JSON.parse(JSON.stringify(res.data))
          delete this.testInfo.stem_list
          // 格式化数据
          let stemList = res.data.stem_list.map((item) => {
            // 问题
            item.title = this.AutoCorrection(item.title)
            // 答案
            if (item.option && item.option.length > 0) {
              for (let i = 0; i < item.option.length; i++) {
                let str = item.option[i].content
                item.option[i].content = this.AutoCorrection(str)
                if (item.option[i].is_right) {
                  this.isRightness = true
                }
              }
            }
            // 学生答案
            if (item.user_answer.answer) {
              if (item.user_answer.answer.length >= 0) {
                for (let i = 0; i < item.user_answer.answer.length; i++) {
                  let str = item.user_answer.answer[i]
                  item.user_answer.answer[i] = this.AutoCorrection(str)
                }
              } else {
                let keylist = Object.keys(item.user_answer.answer) // 获取对象全部key值
                for (let i = 0; i < keylist.length; i++) {
                  let key = keylist[i]
                  let str = item.user_answer.answer[key]
                  item.user_answer.answer[key] = this.AutoCorrection(str)
                }
              }
            }
            return item
          })

          this.testStemList = [] // 清空上一个试卷数据
          // 更改数组结构
          if (stemList && stemList.length > 0) {
            this.formattingData(this.testStemList, stemList) // 生成新数组
            // type为属性名-题目类型
            this.testStemList.sort(this.compare("type")) // 按type字段重新排序
          }
          this.$refs.dialog_testdetail.dialogopenbt() // 打开试卷查看窗口
        }
      })
    },
    // 处理数组-把一个数组拆分为多个数组
    formattingData(arr, data) {
      // 新数组、原数组
      data.forEach((item) => {
        item.active = false // 设置默认无点击状态
        const parent = arr.find((cur) => cur.type === item.type)
        if (parent) {
          parent.child.push(item)
          // 计算分数
          parent.score += item.score
        } else {
          const obj = {
            type: item.type,
            score: item.score,
            child: [item],
          }
          arr.push(obj)
        }
      })
    },
    // 数值排序
    compare(property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    // 循环修正数据与数据格式
    AutoCorrection(str) {
      const that = this
      let newStr = str.replaceAll(/&nbsp;/gi, "") //去除空格字符
      newStr = newStr.replace(/[\r\n]/g, "").trim() // 去与换行与前后空格
      newStr = newStr.replace(/\\/g, "") // 去除反斜杠
      newStr = newStr.replace(/\s+/g, " ") // 去除多余空格
      // newStr = newStr.replace(/<p>(\s|\&nbsp\;| |　|\xc2\xa0)*<\/p>/ig, ""); // 去掉多余 P 标签
      // 判断是否有图片，如果有图片
      let isHavePic = newStr.includes("<img")
      if (isHavePic) {
        // 正则过滤出图片
        newStr.replace(/<img.+?>/gi, function (matchImg, captureImg) {
          // console.log("正则匹配所有图片并获取相应下标==>",matchImg, captureImg);
          // newStr = newStr.replace(match,""); // 清除图片
          let resImgSrc = "" // 自定义变量接收图片
          matchImg.replace(
            /<img[^>]*src=['"]([^'"]+)[^>]*>/gi,
            function (matchSrc, captureSrc) {
              // console.log("正则匹配该图片并获取相应路径==>",matchSrc, captureSrc);
              resImgSrc = captureSrc.replace(
                "../uploads",
                that.$api.baseUrl + "/uploads"
              )
            }
          )
          // 在图片中插入点击事件并默认不展示
          let newImgStr = matchImg.replace(
            /<s?img[^>]*src=['"]([^'"]+)/gi,
            `<img src="${resImgSrc}" style="max-width:80%; margin: 4px;"`
          )
          newStr = newStr.replace(matchImg, newImgStr)
        })
      }
      // 判断是否有视频，如果有视频
      let isHaveMove = newStr.includes("<video")
      if (isHaveMove) {
        // 正则过滤出视频
        newStr.replace(
          /(<video[\s\S]*?>)[\s\S]*?(<\/video>)/gi,
          function (matchVideo, captureVideo) {
            // console.log("正则匹配所有视频并获取相应下标==>",matchVideo, captureVideo);
            // newStr = newStr.replace(matchVideo,""); // 清空视频
            let resMoveurl = "" // 自定义变量接收视频
            matchVideo.replace(
              /<source [^>]*src=['"]([^'"]+)[^>]*>/gi,
              function (matchUrl, captureUrl) {
                // console.log("正则匹配该视频并获取相应路径==>",matchUrl, captureUrl);
                resMoveurl = captureUrl.replace(
                  "../uploads",
                  that.$api.baseUrl + "/uploads"
                )
              }
            )
            let newMoveStr = matchVideo.replace(
              /<s?video[\s\S]*?>[\s\S]*?<\/video>/gi,
              `<video controls="controls" style="max-width:80%; margin: 4px;"><source src="${resMoveurl}" type="video/mp4"/></video>`
            )
            newStr = newStr.replace(matchVideo, newMoveStr)
          }
        )
      }
      return newStr
    },
    // 大写数字自动编号
    AutoNumberByIndex(vNumber) {
      var vLetter = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
      ]
      if (vNumber < 10) {
        return vLetter[vNumber]
      }
    },
    // 字母自动编号
    AutoNumberByLetter(vNumber) {
      var vLetter = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ]
      if (vNumber < 26) {
        return vLetter[vNumber]
      } else {
        var vInt = parseInt((vNumber + 1) / 26)
        var vRemainder = (vNumber + 1) % 26
        if (vRemainder == 0) {
          vInt = vInt - 1
          vRemainder = 26
        }
        return vLetter[vInt - 1] + vLetter[vRemainder - 1]
      }
    },
    //附件在线查看
    appendix(url) {
      let fileUrl = ""
      if (typeof url === 'string') {
        fileUrl = url
      } else if (url && url.url) {
        fileUrl = url.url
      }
      if (fileUrl) {
        this.previewUrl = this.filePreview + encodeURIComponent(Base64.encode(fileUrl))
        this.appendixDialogVisible = true
      } else {
        this.$message.warning("无法预览该附件")
      }
    },
    // 关闭附件预览弹框
    handleAppendixClose() {
      this.appendixDialogVisible = false
      this.previewUrl = ""
    },
  },
};
</script>
<style lang="scss" scoped>
.main-contain {
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
  border-radius: 12px;
  margin-top: 14px;
  min-height: 400px;
  width: 100%;
  position: relative;

  .contain {
    margin-top: 10px;
    width: 100%;
    position: relative;
    min-height: 400px;
    background: url(~@/assets/course/UIout/VR/AR_decor_02.png) no-repeat;
    background-position: right bottom;
    padding: 30px;
    box-sizing: border-box;

    .hw-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .intro-title {
        display: flex;
        align-items: center;
        gap: 10px;

        .title-icon {
          // width: 32px;
          // height: 32px;
          flex-shrink: 0;
        }

        .title-text {
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;
          letter-spacing: 1px;
          position: relative;
          left: -50%;
        }
      }

      .hw-actions {
        .type-select {
          width: 120px;

          ::v-deep .el-input__inner {
            border-radius: 20px;
          }
        }
      }
    }

    .hw-filters {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;

      .filter-item {
        padding: 8px 18px;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        border-radius: 20px;
        font-size: 14px;
        color: #666666;
        cursor: pointer;
        user-select: none;
        transition: all 0.3s;

        &:hover {
          color: #6a5af9;
          border-color: #6a5af9;
        }

        &.active {
          background: rgba(106, 90, 249, 0.1);
          border-color: #6a5af9;
          color: #6a5af9;
        }

        .filter-count {
          margin-left: 4px;
          font-size: 13px;
        }
      }
    }

    .hw-list {
      .hw-card {
        margin-bottom: 16px;
        padding: 20px;
        background: #ffffff;
        border: 1px solid #edeaff;
        border-radius: 16px;
        transition: all 0.3s;
        position: relative;

        &:hover {
          box-shadow: 0 4px 16px rgba(106, 90, 249, 0.08);
        }

        .hw-card-main {
          display: flex;
          align-items: center;
          gap: 16px;

          .hw-icon {
            width: 48px;
            height: 48px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 12px;

            i {
              font-size: 24px;
              color: #ffffff;
            }

            &.homework {
              background: linear-gradient(135deg, #8b7cff 0%, #6a5af9 100%);
            }

            &.exam {
              background: linear-gradient(135deg, #5dcfff 0%, #3d84ff 100%);
            }
          }

          .hw-info {
            flex: 1;
            min-width: 0;

            .hw-title-row {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 10px;
              margin-bottom: 8px;

              .hw-title {
                font-size: 16px;
                font-weight: 600;
                color: #333333;
              }

              .hw-type-tag {
                padding: 2px 8px;
                font-size: 12px;
                border-radius: 4px;

                &.homework-tag {
                  color: #6a5af9;
                  background: rgba(106, 90, 249, 0.1);
                  // border: 1px solid #6a5af9;
                  border-radius: 30px;
                }

                &.exam-tag {
                  color: #3d84ff;
                  background: rgba(61, 132, 255, 0.1);
                  border-radius: 30px;
                  // border: 1px solid #3d84ff;
                }
              }
            }

            .hw-chapter {
              font-size: 13px;
              color: #999999;
            }

            .line {
              height: 47px;
              border-radius: 0px 0px 0px 0px;
              border: 1px solid;
              opacity: 0.5;
              border-image: linear-gradient(180deg, rgba(128, 112, 250, 0), rgba(128, 112, 250, 1), rgba(128, 112, 250, 0)) 1 1;
            }
          }

          .hw-metrics {
            display: flex;
            align-items: center;
            gap: 40px;
            flex-shrink: 0;
            width: 50%;

            .metric-item {
              text-align: center;

              .metric-label {
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }

              .metric-value {
                margin-top: 10px;
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }
            }

            .line {
              height: 47px;
              border-radius: 0px 0px 0px 0px;
              border: 1px solid;
              opacity: 0.5;
              border-image: linear-gradient(180deg, rgba(128, 112, 250, 0), rgba(128, 112, 250, 1), rgba(128, 112, 250, 0)) 1 1;
            }
          }

          .hw-status {
            width: 110px;
            flex-shrink: 0;
            text-align: center;

            .btn-primary {
              display: inline-block;
              padding: 8px 18px;
              background: #6a5af9;
              border-radius: 16px;
              font-size: 14px;
              color: #ffffff;
              cursor: pointer;
              user-select: none;
              transition: all 0.3s;

              &:hover {
                background: #7b6cfa;
              }
            }

            .status-text {
              font-size: 14px;
              margin-bottom: 6px;

              &.status-gray {
                // color: #999999;
                position: absolute;
                top: 0;
                right: 0;
                background: rgba(170, 170, 170, 0.15);
                font-weight: 500;
                font-size: 14px;
                color: #AAAAAA;
                line-height: 16px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                padding: 10px;
                border-radius: 0px 10px 0px 18px;
              }

              &.status-red {
                // color: #f13218;
                background: rgba(255, 98, 98, 0.15);
                position: absolute;
                top: 0;
                right: 0;
                font-weight: 500;
                font-size: 14px;
                color: #F64343;
                line-height: 16px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                padding: 10px;
                border-radius: 0px 10px 0px 18px;
              }

              &.status-orange {
                // color: #ff9900;
                background: rgba(123, 237, 105, 0.16);
                position: absolute;
                top: 0;
                right: 0;
                font-weight: 500;
                font-size: 14px;
                color: #09D86B;
                line-height: 16px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                padding: 10px;
                border-radius: 0px 10px 0px 18px;
              }
            }

            .score-box {
              margin-bottom: 6px;

              .score-value {
                font-size: 28px;
                font-weight: 700;
                color: #333333;
              }

              .score-unit {
                font-size: 14px;
                color: #999999;
              }
            }

            .link-text {
              font-size: 13px;
              color: #6a5af9;
              cursor: pointer;
              user-select: none;

              &:hover {
                color: #7b6cfa;
              }
            }
          }
        }
      }

      .empty-tip {
        text-align: center;
        padding: 60px 0;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}

.my_test {
  display: block;
  max-width: 100%;
  padding: 5px 10px;

  .remark {
    font-size: 16px;
    padding: 10px;
    box-shadow: 0px 0px 2px 0px #00000050;
  }

  .order {
    min-width: 20px;
    margin-right: 5px;
  }

  .topic_type {
    font-size: 16px;
    height: 50px;
    display: flex;
    align-items: center;

    .classify {
      font-weight: 700;
      margin-right: 10px;
    }
  }

  .subject {
    display: block;
    max-width: 100%;
    padding: 5px 10px;

    .question {
      // font-size: 14px;
      min-height: 40px;
      display: flex;

      // align-items: baseline;
      .score {
        min-width: 40px;
      }

      .title {
        ::v-deep p {
          padding: 0;
          margin: 0;
          margin-bottom: 5px;
        }
      }
    }

    .option {
      font-size: 14px;
      // min-height: 30px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      .qs_right {
        width: 30px;
        height: 30px;
        min-width: 30px;
        text-align: center;
        line-height: 30px;
        border-radius: 50%;
        background: #ffffff;
        border: 1px solid #d8d8d8;
      }

      .qs_active {
        color: #ffffff;
        border-color: #2a7cec;
        background: #2a7cec;
        opacity: 0.9;
      }

      .content {
        ::v-deep p {
          padding: 0;
          margin: 0;
          margin-bottom: 5px;
        }
      }
    }

    .user_answer {
      max-width: 100%;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 0px 0px 5px 0px #00000050;
      display: flex;
      align-items: flex-start;

      .remark {
        // font-size: 14px;
        padding: 0px;
        box-shadow: none;
      }

      .imgAnalysis {
        width: 30px;
        min-width: 30px;
        height: 30px;
        min-height: 30px;
        margin: 5px;
        margin-right: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .user_section {
        max-width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 10px;
        align-items: center;

        .section_title {
          min-width: 80px;
        }
      }

      .answer_item {
        ::v-deep p {
          padding: 0;
          margin: 0;
          margin-bottom: 5px;
        }
      }

      .answer {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
      }

      .file_list {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;

        .file {
          padding: 10px;
          cursor: pointer;
          color: #3d84ff;
        }
      }

      .rightness {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
      }
    }
  }
}

.oa {
  min-width: 30px;
  margin: 0 5px;

  ::v-deep .el-dialog__wrapper {
    position: relative;
    left: 0;
    right: 0;

    .el-dialog {
      width: 100%;
      box-shadow: none;
    }
  }
}

.customdialog {
  position: relative;

  .dialogbody {
    max-height: 60vh;
    overflow-x: hidden;
    overflow-y: auto;
  }
}

::v-deep .custom-dialog .customdialog .dialog-footer {
  height: 10px;
}

/* 响应式 */
@media screen and (max-width: 768px) {
  .homework-test-container {
    padding: 12px;

    .hw-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;

      .hw-title {
        font-size: 16px;

        .hw-count {
          font-size: 13px;
        }
      }

      .hw-type-select {
        width: 100%;
      }
    }

    .hw-filter-bar {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;

      .filter-tags {
        flex-wrap: wrap;
        gap: 8px;

        .filter-item {
          padding: 6px 12px;
          font-size: 13px;
        }
      }
    }

    .hw-list {
      .hw-card {
        padding: 12px;

        .hw-card-main {
          flex-direction: column;
          gap: 10px;

          .hw-left {
            .hw-card-title {
              font-size: 15px;
            }

            .hw-card-tags {
              .hw-tag {
                font-size: 11px;
                padding: 1px 6px;
              }
            }

            .hw-chapter {
              font-size: 13px;
            }

            .hw-meta {
              flex-wrap: wrap;
              gap: 8px;

              .meta-item {
                font-size: 13px;
              }
            }
          }

          .hw-right {
            width: 100%;
            justify-content: flex-start;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .homework-test-container {
    padding: 8px;

    .hw-header {
      .hw-title {
        font-size: 15px;
      }
    }

    .hw-filter-bar {
      .filter-tags {
        .filter-item {
          padding: 5px 10px;
          font-size: 12px;
        }
      }
    }

    .hw-list {
      .hw-card {
        padding: 10px;

        .hw-card-main {
          .hw-left {
            .hw-card-title {
              font-size: 14px;
            }

            .hw-meta {
              .meta-item {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>